<template>
    <div>
        <div class="enqNotesHeader d-flex justify-content-between">
            <span>{{ __(typeName + ' Notes') }}</span>

            <button type="button" class="btn-icon" data-toggle="modal" @click="createNew" v-if="canEdit">
                <i class="fa fa-plus text-success"></i>
            </button>
        </div>

        <div class="enqNotes">
            <div v-if="error" class="alert alert-danger mb-0 rounded-0">
                {{ error }}
            </div>

            <div v-if="!error && !notes" class="alert alert-info">
                {{  __('Loading...') }}
            </div>
            <div v-else-if="!notes || 0 === notes.length" class="enqNotesEmpty">
                {{  __('Be the first to make a comment above.') }}
            </div>

            <div v-else>
                <enq-note v-for="(note, key) in notes"
                    :key      ="key"
                    :body     ="note.body"
                    :user     ="note.user"
                    :pinned   ="note.pinned"
                    :index    ="key"
                    :date-time="note.dateTime"
                    :icon-path="iconPath"
                    :can-edit ="canEdit"
                    :can-pin  ="canEdit"

                    :on-toggle-pin="onTogglePin"
                    :on-edit      ="onEdit"
                    :on-delete    ="onDelete"
                ></enq-note>
            </div>
        </div>

        <div class="enqNotesFooter"></div>

        <!-- Modal -->
        <!-- TODO: component -->
        <transition name="modal" v-if="modalShown">
            <div class="modal-mask">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ __(modalEditing ? 'Edit ' + typeName + ' Note' : 'Add New ' + typeName + ' Note') }}</h5>

                            <button type="button" class="close" @click="modalShown = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <form autocomplete="off">
                                <div class="form-group">
                                    <label for="message-text" class="col-form-label">{{ __('Body') }}:</label>
                                    <textarea class="form-control" id="message-text" v-model="modalBody" rows="8"></textarea>
                                </div>
                            </form>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="saveModal">{{ __('Save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "EnqPortionNotes",

    props: {
        noteType: {
            required: true,
            type: String,
        },

        enquiryId: {
            required: true,
            type: Number,
        },

        invalidationId: {
            required: false,
            type: Number,
        },

        iconPath: {
            required: true,
            type: String,
        },

        isManager: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            notes: null,
            error: null,

            modalShown: false,
            modalEditing: false,
            modalIndex: null,
            modalBody: "",
        };
    },

    computed: {
        typeName() {
            return (
                this.noteType.charAt(0).toUpperCase() + this.noteType.slice(1)
            );
        },

        canEdit() {
            return this.isManager || authed.permissions.includes("notes");
        },
    },

    methods: {
        onEdit(key) {
            let note = this.notes[key];

            this.modalEditing = true;
            this.modalIndex = key;
            this.modalBody = note.body;
            this.modalShown = true;
        },

        createNew() {
            this.modalEditing = false;
            this.modalIndex = null;
            this.modalBody = "";
            this.modalShown = true;
        },

        saveModal() {
            this.modalShown = false;

            if (this.modalEditing) {
                if (null === this.modalIndex) {
                    console.error("editing with no index?!");

                    return;
                }

                this.updateExisting(this.modalIndex, this.modalBody);
            } else {
                this.submitNew(this.modalBody);
            }
        },

        onDelete(key) {
            let note = this.notes[key];

            axios
                .post("/api/enquiries/notes/" + this.noteType + "/delete", {
                    noteID: note.ID,
                })
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        this.error = data.message || "Unknown error";
                    } else {
                        this.notes = data.notes;
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    this.error = error.toString() || "Unknown error";
                });
        },

        // sortNotes() {
        //     this.notes.sort((a, b) => (a.dateTime > b.dateTime ? 1 : -1));
        //     this.notes.sort((a, b) => (a.pinned ? 0 : 1));
        // },

        onTogglePin(key) {
            let note = this.notes[key];

            axios
                .post("/api/enquiries/notes/" + this.noteType + "/pin", {
                    noteID: note.ID,
                    pinned: !note.pinned,
                })
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        this.error = data.message || "Unknown error";
                    } else {
                        console.log(data.notes);
                        this.notes = data.notes;
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    this.error = error.toString() || "Unknown error";
                });
        },

        updateExisting(key, body) {
            let note = this.notes[key];

            axios
                .post("/api/enquiries/notes/" + this.noteType + "/update", {
                    noteID: note.ID,
                    body: body,
                })
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        this.error = data.message || "Unknown error";
                    } else {
                        note.body = data.body;
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    this.error = error.toString() || "Unknown error";
                });
        },

        submitNew(body) {
            axios
                .post("/api/enquiries/notes/" + this.noteType + "/submit", {
                    enquiryID: this.enquiryId,
                    body: body,
                })
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        this.error = data.message || "Unknown error";
                    } else {
                        this.notes = data.notes;
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    this.error = error.toString() || "Unknown error";
                });
        },

        getData() {
            axios
                .post("/api/enquiries/notes/" + this.noteType + "/list", {
                    enquiryID: this.enquiryId,
                })
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        this.error = data.message || "Unknown error";
                    } else {
                        this.notes = data.notes;

                        if (null === this.notes) {
                            console.error(data);

                            this.error = "Success but notes null?!";
                        } else {
                            this.error = null;
                        }
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    this.error = error.toString() || "Unknown error";
                });
        },
    },

    watch: {
        invalidationId: function (initialCurrencyId) {
            this.notes = null;
            this.error = null;

            this.getData();
        },
    },

    mounted: function () {
        this.getData();
    },
};
</script>
